<template>
  <div class="">
    <div>
      <div v-cloak>
        <div class="container-fluid px-0 continer-valentine">
          <div class="d-flex flex-column flex-lg-row">
            <div class="col-lg-9 col-xl-7 bg-valentine__wrapper">
              <div class="bg-valentine">
                <div class="text-right text-lg-left">
                  <router-link to="/">
                    <img
                        class="app__logo"
                        src="@/assets/images/logo.svg"
                        alt="Logo greenpeace"
                    />
                  </router-link>
                </div>
                <div>
                  <div class="vcontent__wrapper">
                    <div class="d-block vcontent">
                      <div class="">
                        <div class="container mt-2 mt-lg-5 mt-xl-5">
                          <div class="row" v-if="form.step1">
                            <div class="col-12 col-lg-12">
                              <h1 class="v__title">
                                Wyślij dziką walentynkę!
                              </h1>
                              <div class="v__text">
                                <p>
                                  <br>Ptysiu, misiu, kotku - połowa ludzi tak do siebie woła. A można też tak: moja
                                  tuliłezko! Mój strojnisiu nadobny!
                                </p>
                                <p>
                                  Polska przyroda to nie tylko bogactwo roślin i zwierząt, ale i skarbnica niezwykłych,
                                  pięknych nazw gatunków. Polatucha nocna, głodek mrzygłód, zyzuś tłuścioch - to
                                  prawdziwe stworzenia! Cudne, prawda?
                                </p>
                                <p>
                                  Wylosuj dzikie, przyrodnicze zawołanie do bliskiej Ci osoby, wyślij jej walentynkę
                                  i chrońmy razem nawet największe osobliwości polskiej przyrody! :)
                                </p>
                              </div>
                            </div>

                            <div class="col-12">
                              <b-form class="vform">
                                <div class="row">
                                  <div class="col-lg-12">
                                    <b-form-group>
                                      <div class="vform__label">
                                        1. Wybierz motyw:
                                      </div>
                                      <div class="vform__cardgroup">
                                        <img
                                            v-for="(
                                            imageName, index
                                          ) in imageNames"
                                            :key="index"
                                            @click="selectImage(index)"
                                            :class="{
                                            selected: selectedIndex === index,
                                          }"
                                            class="vform__card"
                                            alt="Card"
                                            :src="
                                            require(`@/assets/images/lasy/${imageName}` + `.mini.jpg`)
                                          "
                                        />
                                      </div>
                                    </b-form-group>
                                  </div>
                                </div>
                              </b-form>
                            </div>
                            <!-- different form for mobile -->
                            <div class="d-lg-none" v-if="form.step1"
                                 style="width: 100%; margin-top: 1rem; margin-bottom: 0">
                              <div class="vform__box" style="width: 100%; margin-top: 1rem; margin-bottom: 0;">
                                <b-form-group>
                                  <div class="vform__genderchoose_header">
                                    2. Wylosuj swoje wyznanie:
                                  </div>
                                  <div class="vform__genderchoose">
                                    <label>
                                      <input
                                          v-model="form.gender" value="female"
                                          type="radio"/> Moja Ty...
                                    </label>
                                    <label>
                                      <input
                                          v-model="form.gender" value="male"
                                          type="radio"/> Mój Ty...
                                    </label>
                                  </div>
                                  <div style="text-align: center">
                                    <div
                                        v-if="form.text == ''"
                                        class="form__submit__secondary font-bold d-inline-flex"
                                        style="margin: auto"
                                        @click="generateValentine"
                                    >
                                      <span>Wylosuj!</span>
                                    </div>
                                  </div>
                                </b-form-group>
                                <div
                                    v-if="selectedIndex !== null"
                                    :class="form.valentineTextColor"
                                    class="vform__selectedImage"
                                    :style="{
                          fontFamily: `Kalam, cursive`,
                          fontSize: `2em`,
                          whiteSpace: `pre-wrap`,
                          backgroundImage: `url(${require(`@/assets/images/lasy/${imageNames[selectedIndex]}`)})`
                        }"
                                    alt="Selected card"
                                >{{ form.text }}</div>
                                <div style="text-align: center; margin-top: 1em;">
                                  <div v-if="form.step1 && form.text != ''"
                                      style="margin-bottom: 2em"
                                  >
                                    <div
                                        class="form__submit__secondary font-bold d-inline-flex"
                                        @click="generateValentine"
                                    >
                                      <span>Losuj ponownie</span>
                                    </div>

                                    <div
                                        class="form__submit font-bold d-inline-flex"
                                        @click="goToStep2"
                                        style=""
                                    >
                                      <span>Dalej!</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="form.step2" class="row">

                            <h1 class="v__title" style="margin-left:auto;margin-right:auto;">
                              Wyślij swoją walentynkę
                            </h1>
                            <div class="v__text">
                              <p style="padding-left:10px;padding-right:10px;">
                                Uzupełnij poniższe pola, aby wysłać walentynkę swojej bliskiej osobie (lub sobie,
                                jeśli chcesz ją zapisać u siebie :) Osoba, do której wyślesz, pozna Twoje imię, ale nie adres email - walentynka będzie wysłana z naszego adresu.
                              </p>
                            </div>

                            <div class="col-lg-12">
                              <div class="d-flex align-items-center">
                                <div class="vform__label">
                                  Od&nbsp;kogo:
                                </div>
                                <b-form-group>
                                  <b-form-input
                                      id="name"
                                      autocomplete="given-name"
                                      v-on:click="onClickElement('name')"
                                      v-model="form.name"
                                      :v="$v.form.name"
                                      required
                                      placeholder="Imię*"
                                      :class="{
                                        'is-invalid': $v.form.name.$error,
                                      }"
                                  ></b-form-input>
                                  <div
                                      v-if="$v.form.name.$dirty"
                                      class="text-danger-name"
                                  >
                                    <div
                                        class="text-danger text-left"
                                        v-if="!$v.form.name.required"
                                    >
                                      <small>Pole wymagane</small>
                                    </div>
                                    <div
                                        class="text-danger text-left"
                                        v-if="!$v.form.name.minLength"
                                    >
                                      <small>
                                        Minimalna długość imienia to 3 znaki
                                      </small>
                                    </div>
                                    <div
                                        class="text-danger text-left"
                                        v-if="!$v.form.name.maxLength"
                                    >
                                      <small>
                                        Zbyt długie imię. Maksymalna długość
                                        to 255 znaków</small
                                      >
                                    </div>
                                  </div>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-lg-12">
                              <div class="d-flex align-items-center">
                                <div class="vform__label">
                                  Twój&nbsp;email:
                                </div>
                                <b-form-group>
                                  <b-form-input
                                      id="email"
                                      :v="$v.form.email"
                                      v-model="form.email"
                                      v-on:click="onClickElement('email')"
                                      type="email"
                                      required
                                      placeholder="Email*"
                                      :class="{
                                        'is-invalid': $v.form.email.$error,
                                      }"
                                  ></b-form-input>
                                  <div v-if="$v.form.email.$dirty">
                                    <div
                                        class="text-danger text-left"
                                        v-if="!$v.form.email.required"
                                    >
                                      <small
                                      >Pole wymagane</small
                                      >
                                    </div>
                                    <div
                                        class="text-danger text-left"
                                        v-if="!$v.form.email.email"
                                    >
                                      <small>Wpisz poprawny email</small>
                                    </div>
                                  </div>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-lg-12">
                              <div class="d-flex align-items-center">
                                <div class="vform__label">
                                  Email&nbsp;odbiorcy:
                                </div>
                                <b-form-group>
                                  <b-form-input
                                      id="recipient"
                                      :v="$v.form.recipient"
                                      v-model="form.recipient"
                                      v-on:click="onClickElement('recipient')"
                                      type="email"
                                      required
                                      placeholder="Email*"
                                      :class="{
                                        'is-invalid': $v.form.recipient.$error,
                                      }"
                                  ></b-form-input>
                                  <div v-if="$v.form.recipient.$dirty">
                                    <div
                                        class="text-danger text-left"
                                        v-if="!$v.form.recipient.required"
                                    >
                                      <small
                                      >Pole wymagane - na ten adres wyślemy Twoją walentynkę</small
                                      >
                                    </div>
                                    <div
                                        class="text-danger text-left"
                                        v-if="!$v.form.recipient.email"
                                    >
                                      <small>Wpisz poprawny email</small>
                                    </div>
                                  </div>
                                </b-form-group>
                              </div>
                            </div>

                            <b-form-group
                                id="consents"
                                class="text-center vform__consents col-lg-12"
                            >
                              <b-form-checkbox-group
                                  v-model="form.consents"
                                  id="consents"
                                  v-on:click="onClickElement('consents')"
                                  class="form__checkboxes"
                              >
                                <b-form-checkbox value="3">
                                  <div class="pt-1">
                                    Wyrażam zgodę na informowanie mnie
                                    mailowo o działaniach Greenpeace
                                    związanych z ochroną środowiska, o
                                    projektach i o możliwościach ich
                                    wsparcia.
                                  </div>
                                </b-form-checkbox>
                              </b-form-checkbox-group>
                            </b-form-group>

                            <div class="text-center col-lg-12">
                              <div
                                  class="form__submit__secondary font-bold d-inline-flex"
                                  @click="goToStep1"
                                  style="margin-right: 2em;"
                              >
                                <span>Wróć</span>
                              </div>
                              <div
                                  class="form__submit font-bold d-inline-flex"
                                  @click="onSubmit"
                              >
                                <span v-if="!isLoading">Wyślij!</span>
                                <div>
                                      <span v-if="isLoading" class="formloader">
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                      </span>
                                </div>
                              </div>
                            </div>

                            <div class="form__legal-notice pb-5 lg-pb-0">
                              <p
                                  v-html="
                                      content.data.form.additional_field_1
                                    "
                              ></p>
                              <p
                                  v-html="content.data.form.legalNotice_6"
                              ></p>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-xl-5 px-0 text--center valentine-generate">
              <div class="d-none d-lg-block">
                <div class="vform__box">

                  <div v-if="form.step1">
                    <b-form-group>
                      <div class="vform__genderchoose_header">
                        2. Wylosuj swoje wyznanie:
                      </div>
                      <div class="vform__genderchoose">
                        <label>
                          <input
                              v-model="form.gender" value="female"
                              type="radio"/> Moja Ty...
                        </label>
                        <label>
                          <input
                              v-model="form.gender" value="male"
                              type="radio"/> Mój Ty...
                        </label>
                      </div>
                      <div style="text-align: center">
                        <div
                            v-if="form.text == ''"
                            class="form__submit__secondary font-bold d-inline-flex"
                            style="margin: auto"
                            @click="generateValentine"
                        >
                          <span>Wylosuj!</span>
                        </div>
                      </div>
                    </b-form-group>
                  </div>

                  <div
                      v-if="selectedIndex !== null"
                      :class="form.valentineTextColor"
                      class="vform__selectedImage"
                      :style="{
                          fontFamily: `Kalam, cursive`,
                          whiteSpace: `pre-wrap`,
                          backgroundImage: `url(${require(`@/assets/images/lasy/${imageNames[selectedIndex]}`)})`
                        }"
                      alt="Selected card"
                  >{{ form.text }}</div>
                  <div style="text-align: center; margin-top: 1em;">
                    <div v-if="form.step1 && form.text != ''">
                      <div
                          class="form__submit__secondary font-bold d-inline-flex"
                          @click="generateValentine"
                      >
                        <span>Losuj ponownie</span>
                      </div>

                      <div
                          class="form__submit font-bold d-inline-flex"
                          @click="goToStep2"
                          style="margin-left: 2em"
                      >
                        <span>Dalej!</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- FOR OPEN PAYU -->
<script>
</script>

<script>
import axios from "axios";

import {
  email,
  required,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

export default {
  name: "Form",
  inject: ["content"],
  data() {
    return {
      title: "Formularz",
      imageNames: ["jeze.jpg", "wiewiory.jpg", "zuki.jpg"],
      selectedIndex: 1,
      windowWidth: 0,
      isLoading: false,
      form: {
        valentineTextColor: "valentine-text-color-yellow",
        step1: true,
        step2: false,
        gender: "male",
        email: "",
        recipient: "",
        name: "",
        text: "",
        phone: "",
        consents: [],
        contactType: [],
      },
    };
  },
  computed: {},
  validations() {
    return {
      form: {
        email: {
          required,
          email,
        },
        recipient: {
          required,
          email,
        },
        name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(255),
        },
        text: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(150),
        },
        consents: {
        },
      },
    };
  },

  methods: {
    generateValentine() {
      const names = {
        male: [
          "graniczniku\npłucniku!",
          "chrobotku\nreniferowy!",
          "kędziorku\nmylny!",
          "ruliku\nnadrzewny!",
          "strojnisiu\nnadobny!",
          "kurzyśladzie\nwątły!",
          "wężymordzie!",
          "podejźrzonie\nksiężycowy!",
          "zyzusiu\ntłuściochu!",
          "głodku\nmrzygłodzie!",
          "nocku\nwąsatku!",
          "karłątku\nleśny!",
          "zębielu\nkarliczku!",
        ],
        female: [
          "zalotko\nwiększa!",
          "zarazo\nkrwistoczerwona!",
          "drżączko!",
          "tuliłezko!",
          "pachnico\ndębowa!",
          "niezdarko\ndziewico!",
          "polatucho\nnocna!",
          "koszatko\nleśna!",
          "gałeczko\nżeberkowana!",
          "ozdobnico\nmniejsza!",
          "uszatko\nbłotna!",
          "grzebiuszko\nziemna!",
        ],
      };
      const getRandomElement = (arr) => arr[Math.floor(Math.random() * arr.length)];
      this.form.text = (this.form.gender === 'male') ? 'Mój Ty' : 'Moja Ty';
      this.form.text += "\n";
      this.form.text += getRandomElement(names[this.form.gender] || []);
    },
    goToStep1() {
      this.form.step1 = true;
      this.form.step2 = false;
    },
    goToStep2() {
      this.form.step1 = false;
      this.form.step2 = true;
    },
    selectImage(index) {
      console.log("Selected image " + index);
      if (index === 1) {
        this.form.valentineTextColor = "valentine-text-color-yellow";
      } else {
        this.form.valentineTextColor = "valentine-text-color-red";
      }
      this.selectedIndex = index;
    },
    onClickElement: function (name) {
      window.trackFormClick(name);
    },

    onSubmit(evt) {
      let onSubmitButton = document.getElementById("onSubmitButton");

      if (onSubmitButton) {
        onSubmitButton.setAttribute("disabled", true);
        setTimeout(() => {
          onSubmitButton.removeAttribute("disabled");
        }, 2000);
      }

      evt.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "formSendError",
          formName: "Formularz",
          errorForm: "1",
        });

        this.validationScrollToError();
        return;
      }
      this.isLoading = !this.isLoading;
      let dataForLead = this.getDataForLead();
      let dataForValentine = this.getDataForValentine();

      axios
          .post(
              "https://bogini2.greenpeace.pl/api/v1/mailings/kocham-lasy",
              dataForValentine,
              {
                headers: {crossDomain: true},
              }
          )
          .then((response) => {
            console.log("valentine has been sent");
          })
          .catch((error) => {
            console.log(
                "An error occurred while making the POST request:",
                error
            );
            this.$router.push("/error");
          });
      axios
          .post(
              "https://bogini2.greenpeace.pl/api/v1/lead-campaigns/kocham-lasy/lead",
              dataForLead,
              {
                headers: {crossDomain: true},
              }
          )
          .then((response) => {
            console.log("get api response");
            this.$router.push("/support");
          })
          .catch((error) => {
            console.log(
                "An error occurred while making the POST request:",
                error
            );
            this.$router.push("/error");
          });
    },

    getDataForLead() {
      let consents = [1];
      if (this.form.consents.length > 0) {
        consents.push(3);
      }
      return {
        name: this.form.name,
        email: this.form.email,
        consents: consents,
        context: {
          text: this.form.text,
          recipient: this.form.recipient,
          gender: this.form.gender,
        },
      };
    },
    getDataForValentine() {
      let boginiImageId = 0;

      let textColor = '#bf1b16';

      if (this.selectedIndex === 0) {
        boginiImageId = 90; // jeze
      }
      if (this.selectedIndex === 1) {
        boginiImageId = 91; // wiewiory
        textColor = '#e2c100';
      }
      if (this.selectedIndex === 2) {
        boginiImageId = 92; // zuki
      }
      return {
        email: this.form.recipient,
        parameters: {
          name: this.form.name,
          image: `https://bogini2.greenpeace.pl/api/v1/image-generators/kocham-lasy/images/${
              boginiImageId
          }?text[kocham-lasy]=${encodeURIComponent(
              this.form.text
          )}&textColor=${encodeURIComponent(textColor)}`,
        },
      };
    },

    validationScrollToError: function () {
      setTimeout(() => {
        if (document.body.clientWidth < 992) {
          let elementsInErrorsName =
              document.getElementsByClassName("text-danger-name");
          if (elementsInErrorsName && elementsInErrorsName.length > 0) {
            let toScrollInputName = document.getElementById("name");
            toScrollInputName.scrollIntoView();
          }
        }
        if (!this.$v.form.text.required) {
          window.errorOnFormField("text", "Pole jest wymagane");
        } else if (!this.$v.form.text.minLength) {
          window.errorOnFormField(
              "text",
              "Minimalna długość tekstu to 3 znaki"
          );
        } else if (!this.$v.form.text.maxLength) {
          window.errorOnFormField(
              "text",
              "Zbyt długi tekst. Maksymalna długość to 155 znaków"
          );
        }
        if (!this.$v.form.name.required) {
          window.errorOnFormField("name", "Pole jest wymagane");
        } else if (!this.$v.form.name.minLength) {
          window.errorOnFormField(
              "name",
              "Minimalna długość imienia to 3 znaki"
          );
        } else if (!this.$v.form.name.maxLength) {
          window.errorOnFormField(
              "name",
              "Zbyt długie imię. Maksymalna długość to 255 znaków"
          );
        }
        if (!this.$v.form.email.required) {
          window.errorOnFormField("email", "Pole jest wymagane");
        } else if (!this.$v.form.email.email) {
          window.errorOnFormField("email", "Wpisz poprawny email");
        }
        if (!this.$v.form.recipient.required) {
          window.errorOnFormField("recipient", "Pole jest wymagane");
        } else if (!this.$v.form.recipient.email) {
          window.errorOnFormField("recipient", "Wpisz poprawny email");
        }
      }, 50);
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    showTooltipButonSubFn() {
      this.showTooltipButonSub = false;
    },
  },
  watch: {},

  components: {},
  props: {
    thanks: Boolean,
  },
  /*   mounted() {
    // TODO obrazki
    axios
      .get(
        "https://bogini2.greenpeace.pl/api/v1/image-generators/kocham-wilki",
        {
          headers: { crossDomain: true },
        }
      )
      .then((response) => {
        console.log("obrazki", response);
      });
  }, */
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
